import React, { useMemo } from "react";
import {
  faArrowRight,
  faBook,
  faDesktop,
  faFileLines,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth0 } from "@auth0/auth0-react";
import { usePermissions } from "../context/PermissionContext";
import {
  filterNavByPermission,
  STUDENT_HOME_CONTROLS,
} from "../utils/adminNavigation";
import { emailsEqual } from "../utils/emailCompare";

const CONTROL_META = {
  LECTURES: {
    icon: faDesktop,
    blurb: "Watch recorded and live class sessions.",
  },
  NOTES: {
    icon: faBook,
    blurb: "Open curated notes for every topic.",
  },
  WORKSHEETS: {
    icon: faFileLines,
    blurb: "Practice with worksheets and drills.",
  },
  REGISTRATION: {
    icon: faPenToSquare,
    blurb: "Enrol in the courses that fit you.",
  },
};

function MainButtonControls() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth0();
  const { permissions, loading: permsLoading } = usePermissions();

  const isSuperAdmin =
    isAuthenticated &&
    emailsEqual(user?.email, process.env.REACT_APP_SUPER_USER_EMAIL);

  const visibleControls = useMemo(() => {
    if (!isAuthenticated || permsLoading) return [];
    return filterNavByPermission(STUDENT_HOME_CONTROLS, permissions, {
      isSuperAdmin,
    });
  }, [isAuthenticated, permissions, permsLoading, isSuperAdmin]);

  if (!visibleControls.length) return null;

  return (
    <section
      className="student-section student-controls"
      aria-label="Quick links"
    >
      <div className="student-section__inner">
        <header className="student-section__header student-section__header--center">
          <p className="student-section__eyebrow">Start here</p>
          <h2 className="student-section__title">Quick access</h2>
        </header>
        <div className="student-controls__grid">
          {visibleControls.map((control) => {
            const meta = CONTROL_META[control.name] || {};
            return (
              <button
                key={control.name}
                type="button"
                className="student-controls__card"
                style={{ "--control-accent": control.color }}
                onClick={() => navigate(control.path)}
                aria-label={control.name}
              >
                <span className="student-controls__icon-wrap" aria-hidden="true">
                  <FontAwesomeIcon
                    icon={meta.icon}
                    className="student-controls__icon"
                  />
                </span>
                <span className="student-controls__text">
                  <span className="student-controls__label">{control.name}</span>
                  {meta.blurb && (
                    <span className="student-controls__blurb">{meta.blurb}</span>
                  )}
                </span>
                <span className="student-controls__go" aria-hidden="true">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default MainButtonControls;
